
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Logo } from "@/components/ui/Logo";
import { CompleteProfileForm } from "@/components/auth/CompleteProfileForm";
import { useAuth } from "@/context/AuthContext";
import { Progress } from "@/components/ui/progress";

const CompleteProfile = () => {
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // If no user or still loading, do nothing
    if (isLoading) return;
    
    // If user is not logged in, redirect to login
    if (!user) {
      navigate("/login");
      return;
    }
    
    // If the user already has all required profile data, redirect to dashboard
    if (user.document && user.phone && user.address) {
      navigate("/dashboard");
    }
    
    // Calculate profile completion progress
    const fieldsToCheck = [user.document, user.phone, user.address];
    const completedFields = fieldsToCheck.filter(Boolean).length;
    setProgress((completedFields / fieldsToCheck.length) * 100);
  }, [user, isLoading, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-brand-teal to-brand-coral dark:from-brand-teal/90 dark:to-brand-coral/90 py-8">
      <div className="w-full max-w-lg px-4 my-8">
        <Card className="shadow-lg border-0 backdrop-blur-sm bg-white/95 dark:bg-gray-900/95">
          <CardHeader className="space-y-4 text-center pb-4 pt-8">
            <div className="mx-auto">
              <Logo size="lg" clickable={false} />
            </div>
            <CardTitle className="text-2xl">Complete seu perfil</CardTitle>
            <CardDescription className="text-gray-600 dark:text-gray-300 text-base">
              Precisamos de mais algumas informações para configurar sua conta
            </CardDescription>
            
            <div className="pt-2">
              <Progress value={progress} className="h-2" />
              <p className="text-sm text-muted-foreground mt-1">
                Perfil {Math.round(progress)}% completo
              </p>
            </div>
          </CardHeader>
          
          <CardContent className="pb-8 px-6">
            <CompleteProfileForm />
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

// This property tells the app not to use the global layout for this page
CompleteProfile.getLayout = (page: React.ReactNode) => page;

export default CompleteProfile;
